import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../CancelReservationModal.messages';
export var CancelReservationResult = function CancelReservationResult(_ref) {
  var details = _ref.details,
      heading = _ref.heading,
      onModalClose = _ref.onModalClose,
      studio = _ref.studio;
  return React.createElement("section", {
    className: "modal__body"
  }, React.createElement("div", {
    className: "modal__confirmation-message"
  }, heading), React.createElement("div", {
    className: "delta mv-"
  }, studio), React.createElement("p", {
    className: "mb"
  }, details), React.createElement("button", {
    className: "bt bt--primary bt--lg mb-",
    onClick: onModalClose
  }, React.createElement(FormattedMessage, messages.doneCta)));
};
CancelReservationResult.propTypes = {
  details: PropTypes.node.isRequired,
  heading: PropTypes.node.isRequired,
  onModalClose: PropTypes.func.isRequired,
  studio: PropTypes.string.isRequired
};